import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation } from "@tanstack/vue-query";
import profileService from "@/services/profile.js";

// The URL only has to outlive the render that consumes it.
export const PRESIGN_EXPIRATION_SECONDS = 60;

export interface PresignSubmissionFileVariables {
  bucket: string;
  key: string;
  submissionId: string | undefined;
}

// Every presigned URL for a submission file is minted here, so the request payload
// has a single definition. Modelled as a mutation rather than a query because the
// backend records one access row per call, making a cached result a silent loss of
// audit detail.
export const useSubmissionFilePresign = (
  useMutationOptions?: UseMutationOptions<string | undefined, Error, PresignSubmissionFileVariables>,
) => {
  return useMutation<string | undefined, Error, PresignSubmissionFileVariables>({
    mutationFn: async ({ bucket, key, submissionId }) => {
      const response = await profileService.getDocumentPreSignedUrl({
        bucket_name: bucket,
        object_name: key,
        expiration: PRESIGN_EXPIRATION_SECONDS,
        submission_id: submissionId,
      });
      return response?.data?.data?.url;
    },
    ...useMutationOptions,
  });
};
